/**
 * Envoie de la newsletter
 */
$('#form_newsletter').on('submit', function(event){
    event.preventDefault();

    let email = $('[name="emailNewsletter"]').val();
    let checkRgpd = $('[name="checkRGPDnewsletter"]').is(':checked');

    $('[name="emailNewsletter"]').val("");
    $('[name="emailNewsletter"]').attr('disabled', true);

    fetch(`/controller/residence/newsletter?email=${email}&rgpd=${checkRgpd}`, {
        method: 'GET',
    })
    .then(res => res.json())
    .then(json => {

        if (json.error !== null) {
            $('#newsletterBlock').append(renderAlert(json.error));
            $('[name="emailNewsletter"]').attr('disabled', false);
            return;
        }

        if (json.message) {
            $('#form_newsletter').addClass('d-none');
            $('#newsletterBlock').append(renderAlert(json.message));
        }
    })
})

/**
 * Supprime le message d'alerte lorsqu'on resaisie dans l'input email
 */
$('[name="emailNewsletter"]').on('input', function(){
    let alertBlock = $('#newsletterMessage');

    if (alertBlock.length > 0) {
        $('#newsletterMessage').remove();
    }
})

/**
 * @param {string} message
 * @return {string} 
 */
function renderAlert(message) 
{
    return `
        <div 
            class="alert alert-secondary" 
            role="alert" 
            id="newsletterMessage"
        >
            ${message}
        </div>
    `
}